import 'css-chunksrc/client/scenes/projectExpenseEdition/styles.scss';export default {
  "form": "_form_1ppts_1",
  "footer": "_footer_1ppts_5",
  "button": "_button_1ppts_13"
};